/* eslint-disable @direct-frontend/modules/slice-boundaries -- подумать как уйти от соседних зависимостей */
import { useMemo } from 'react';
import { type FiltersDeclaration } from '@adv-frontend/filters';
import { CATEGORY_FILTER_ID, CATEGORY_FILTER_TITLE } from '#entities/category';
import { type OpenApiSchemaCharacteristicMeta } from '#shared/api/schema';
import { filterEmpty } from '#shared/lib/array';
import {
    BADGES_FILTER_TITLE,
    BRAND_FILTER_TITLE,
    PRODUCT_COLLECTION_FILTER_TITLE,
    PRODUCT_FILTER_BADGES_ID,
    PRODUCT_FILTER_BRAND_ID,
    PRODUCT_FILTER_COLLECTION_ID,
} from '../constants';
import { createExistenceFilter } from '../lib/filters';
import { type ProductFilterDeclaration } from './useProductFiltersDeclaration';

export const useProductFiltersExistenceDeclaration = (
    characteristics: OpenApiSchemaCharacteristicMeta[] | undefined
) => {
    const beforeCharacteristicsDeclaration: ProductFilterDeclaration[] = useMemo(() => {
        const filters: ProductFilterDeclaration[] = [
            createExistenceFilter({
                id: CATEGORY_FILTER_ID,
                title: CATEGORY_FILTER_TITLE,
            }),
            createExistenceFilter({ id: PRODUCT_FILTER_BRAND_ID, title: BRAND_FILTER_TITLE }),
            createExistenceFilter({
                id: PRODUCT_FILTER_BADGES_ID,
                title: BADGES_FILTER_TITLE,
            }),
            createExistenceFilter({
                id: PRODUCT_FILTER_COLLECTION_ID,
                title: PRODUCT_COLLECTION_FILTER_TITLE,
            }),
        ].filter(filterEmpty);

        return filters;
    }, []);

    const characteristicsDeclaration: ProductFilterDeclaration[] = useMemo(
        () => (characteristics || []).map(({ slug, title }) => createExistenceFilter({ id: slug, title })),
        [characteristics]
    );

    const filtersDeclaration: FiltersDeclaration<ProductFilterDeclaration> = {
        dynamicFilters: beforeCharacteristicsDeclaration.concat(characteristicsDeclaration),
    };

    return filtersDeclaration;
};
